var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputCaret({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.71,
    height: 6.643,
    viewBox: "0 0 11.71 6.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-down",
    d: "M12.083,198.643H22.218a.786.786,0,0,0,.555-1.343l-5.065-5.069a.789.789,0,0,0-1.115,0L11.528,197.3A.786.786,0,0,0,12.083,198.643Z",
    transform: "translate(-11.295 -192)",
    fill: "#3b4b6c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCaret);
export default __webpack_public_path__ + "static/media/input_caret.8550e20af6396fae1d0281a409c4274f.svg";
export { ForwardRef as ReactComponent };